import { getAccessControlsRpc, patchAccessControlsRpc } from '../../__generated__/chirp/com/hubspot/ai/access/controls/rpc/AiAccessControlsChirpService';
import { rpcClient } from './apiClient';
export const getAccess = () => {
  return rpcClient.call(getAccessControlsRpc, {});
};
export const updateAccess = ({
  patch
}) => {
  return rpcClient.call(patchAccessControlsRpc, {
    request: patch
  });
};